var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Trio-wrapper"},[_c('funnel-header'),(_vm.step == 1)?_c('funnel-from'):_vm._e(),(_vm.step == 2)?_c('congratulations'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }